import type { SyntheticEvent } from 'react';
import { createContext, useContext } from 'react';

import type { TTheme, TIconAlign } from './models';

export type TToggleHandler = (args: { event: SyntheticEvent<HTMLDivElement>; id?: string }) => void;

export interface IContext {
    dividerEnabled?: boolean;
    handleToggle: TToggleHandler;
    iconPosition: TIconAlign;
    keepMounted?: boolean;
    newDesign?: boolean;
    openedValue?: string[] | null;
    theme?: TTheme;
}

export const AccordionContext = createContext<IContext>({
    handleToggle: /* istanbul ignore next */ () => {},
    iconPosition: 'left',
    newDesign: false,
});

export const useAccordionContext = () => useContext(AccordionContext);
